<template>
  <div class="card notification ddialog">
    <h1 class="title">Add new event</h1>

    <b-field :type="{'is-danger': errors.has('date')}" :message="errors.first('date')">
      <b-datepicker
        name="date"
        placeholder="Select date"
        v-model="event.date"
        :first-day-of-week="1"
        icon="calendar-today"
        v-validate="'required'"
      ></b-datepicker>
    </b-field>

    <b-field :type="{'is-danger': errors.has('title')}" :message="errors.first('title')">
      <b-input
        type="string"
        placeholder="Title"
        name="title"
        v-validate="'required'"
        v-model="event.name"
      ></b-input>
    </b-field>

    <b-field>
      <b-field :type="{'is-danger': errors.has('bands1')}" :message="errors.first('bands1')">
        <b-taginput
          v-model="bands"
          :data="filteredBands"
          field="name"
          icon="label"
          autocomplete
          :allow-new="false"
          placeholder="Add a band"
          expanded
          name="bands1"
          @typing="getFilteredBands"
          v-validate="'required'"
        ></b-taginput>
      </b-field>
    </b-field>

    <div v-for="(v, i) in videos" :key="bands[i].name">
      <b-field :label="bands[i].name">
        <b-input v-model="v.url" placeholder="Youtube video"></b-input>
      </b-field>
    </div>

    <b-field :type="{'is-danger': errors.has('venue')}" :message="errors.first('venue')">
      <b-select
        placeholder="Select a venue"
        expanded
        v-model="event.venue"
        name="venue"
        v-validate="'required'"
      >
        <option v-for="v in venues" :value="v" :key="v.name">{{ v.name }}</option>
      </b-select>
    </b-field>

    <b-field
      class="file"
      :type="{'is-danger': errors.has('flyer')}"
      :message="errors.first('flyer')"
    >
      <b-upload v-model="file" name="flyer" v-validate="'required'">
        <a class="button is-primary">
          <b-icon icon="upload"></b-icon>
          <span>Upload flyer</span>
        </a>
      </b-upload>
      <span class="file-name" v-if="file">{{ file.name }}</span>
    </b-field>
    <button class="button is-success" @click="validateBeforeSubmit">Save event</button>
  </div>
</template>

<script>
const axios = require("axios");

export default {
  name: "CreateEvent",
  data() {
    return {
      file: null,
      filename: "",
      venue: {},
      venues: this.$store.getters.venues,
      availableBands: this.$store.getters.bands,
      filteredBands: [],
      bands: [],
      videos: {}
    };
  },
  watch: {
    bands: function(val) {
      this.videos = [];
      for (var i in val) {
        var b = val[i];
        console.log(b);
        var vid = { url: "", bandId: b.ID };
        this.videos[i] = vid;
      }
    }
  },
  props: ["event"],
  methods: {
    getFilteredBands(text) {
      this.filteredBands = this.availableBands.filter(option => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(text.toLowerCase()) >= 0
        );
      });
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.uploadFlyer();
          return;
        }
        this.$toast.open({
          message: "Form is not valid! Please check the fields.",
          type: "is-danger",
          position: "is-bottom"
        });
      });
    },
    uploadFlyer() {
      let formData = new FormData();
      formData.append("file", this.file);
      axios
        .post(this.$backend + "/api/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "X-Filename": this.filename
          }
        })
        .then(response => {
          if (response.status == 200) {
            this.$toast.open({
              message: "Flyer upload",
              type: "is-info"
            });
            this.saveEvent(response.data.fileName);
          } else {
            this.$toast.open({
              message: "Error while uploading flyer",
              type: "is-error"
            });
          }
        });
    },
    saveEvent(flyer) {
      this.event.bands = this.bands;
      this.event.flyer = flyer;
      this.event.videos = this.videos;
      axios.post(this.$backend + "/api/events", this.event).then(response => {
        if (response.status == 200) {
          this.$toast.open({
            message: "Event created",
            type: "is-info"
          });
          this.$validator.clear();
          this.event = {};
          this.bands = [];
          this.videos = [];
          //TODO: clear validation
        } else {
          this.$toast.open({
            message: "Error while creating event!",
            type: "is-error"
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.ddialog {
  min-width: 400px;
}
</style>
